export const GROUP_VULNS_FETCHING = 'GROUP_VULNS_FETCHING';
export const GROUP_VULNS_FAIL = 'GROUP_VULNS_FAIL';
export const GROUP_VULNS_CLEAR_ERROR = 'GROUP_VULNS_CLEAR_ERROR';

export const GROUP_VULNS_CREATE_SUCCESS = 'GROUP_VULNS_CREATE_SUCCESS';
export const GROUP_VULNS_ADD_SUCCESS = 'GROUP_VULNS_ADD_SUCCESS';
export const GROUP_VULNS_REMOVE_SUCCESS = 'GROUP_VULNS_REMOVE_SUCCESS';
export const GROUP_VULNS_DELETE_SUCCESS = 'GROUP_VULNS_DELETE_SUCCESS';
export const GROUP_VULNS_RENAME_SUCCESS = 'GROUP_VULNS_RENAME_SUCCESS';
export const GROUP_VULNS_EXPLORE = 'GROUP_VULNS_EXPLORE';

export const GROUP_VULNS_EXPLORE_OPEN = 'GROUP_VULNS_EXPLORE_OPEN';
export const GROUP_VULNS_EXPLORE_CLOSE = 'GROUP_VULNS_EXPLORE_CLOSE';
export const GROUP_VULNS_EXPLORE_SET_ACTIVE_TAB = 'GROUP_VULNS_EXPLORE_SET_ACTIVE_TAB';
export const GROUP_VULNS_EXPLORE_SET_HOSTS_PAGE = 'GROUP_VULNS_EXPLORE_SET_HOSTS_PAGE';
export const GROUP_VULNS_EXPLORE_SET_SERVICES_PAGE = 'GROUP_VULNS_EXPLORE_SET_SERVICES_PAGE';
export const GROUP_VULNS_EXPLORE_HOSTS_FETCHING = 'GROUP_VULNS_EXPLORE_HOSTS_FETCHING';
export const GROUP_VULNS_EXPLORE_HOSTS_SUCCESS = 'GROUP_VULNS_EXPLORE_HOSTS_SUCCESS';
export const GROUP_VULNS_EXPLORE_HOSTS_FAIL = 'GROUP_VULNS_EXPLORE_HOSTS_FAIL';
export const GROUP_VULNS_EXPLORE_SERVICES_FETCHING = 'GROUP_VULNS_EXPLORE_SERVICES_FETCHING';
export const GROUP_VULNS_EXPLORE_SERVICES_SUCCESS = 'GROUP_VULNS_EXPLORE_SERVICES_SUCCESS';
export const GROUP_VULNS_EXPLORE_SERVICES_FAIL = 'GROUP_VULNS_EXPLORE_SERVICES_FAIL';
export const GROUP_VULNS_EXPLORE_SHOW_UNGROUP_CONFIRMATION_MODAL = 'GROUP_VULNS_EXPLORE_SHOW_UNGROUP_CONFIRMATION_MODAL';
export const GROUP_VULNS_EXPLORE_HIDE_UNGROUP_CONFIRMATION_MODAL = 'GROUP_VULNS_EXPLORE_HIDE_UNGROUP_CONFIRMATION_MODAL';
export const GROUP_VULNS_EXPLORE_SET_SELECTED_HOST_IDS = 'GROUP_VULNS_EXPLORE_SET_SELECTED_HOST_IDS';
export const GROUP_VULNS_EXPLORE_SET_SELECTED_SERVICE_IDS = 'GROUP_VULNS_EXPLORE_SET_SELECTED_SERVICE_IDS';
export const GROUP_VULNS_EXPLORE_UPDATE_HOST_TAGS = 'GROUP_VULNS_EXPLORE_UPDATE_HOST_TAGS';
export const GROUP_VULNS_EXPLORE_UPDATE_SERVICE_TAGS = 'GROUP_VULNS_EXPLORE_UPDATE_SERVICE_TAGS';
export const GROUP_VULNS_EXPLORE_HOSTS_DELETE_SUCCESS = 'GROUP_VULNS_EXPLORE_HOSTS_DELETE_SUCCESS';
export const GROUP_VULNS_EXPLORE_SERVICES_DELETE_SUCCESS = 'GROUP_VULNS_EXPLORE_SERVICES_DELETE_SUCCESS';
